export default {
  icon: ' mdi-badge-account-horizontal-outline',
  text: 'Funcionários',
  permissions: [
    { name: 'employeeIndex', text: 'Visualizar Funcionários', value: 0 },
    { name: 'employeeCreateEdit', text: 'Cadastrar/Editar Funcionários', value: 0 },
  ]
}